import type { Currency } from '~~/domains/graphql';

export function convertTo(
  amount: number,
  source?: Currency,
  target?: Currency,
) {
  if (!source || !target) return amount;
  if (source.code === target.code) return amount;

  const rawAmount = amount * (source.euroRate / target.euroRate);
  const fixedAmount = rawAmount.toFixed(2);

  if (fixedAmount.endsWith('00')) {
    return Number(fixedAmount.split('.')[0]);
  }

  return Number(fixedAmount);
}
